import React from 'react';
import { Icon } from './Icon.js';
export const IconRotateObjAnticlockwise = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M14 11L14 21L4 21L4 11L14 11Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M20 12V4H11H12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.5 1.5L10.9645 4.03554L13.5 6.57107", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconRotateObjAnticlockwise.js.map